function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVelgFilm = function SvgVelgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 47"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m871.212 1051.01.145-1.93-4.4.43-3.948-40.96 26.653-2.55.5 5.17 10.851.81-3.1 41.03Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-863 -1006)"
  }));
};
export default SvgVelgFilm;